<template>
    <div id="app-container" class="app-container flex row vertical-center space-evenly">
        <div>
            <div class="flex row mobile-direction">
                <div class="mobile-center">
                    <img class="page-num" :src="require('../../assets/Desktop/About_Us/03-img.svg')" alt="Page 3">
                </div>
                <div>
                    <p class="app-royal-text md-container">Royal Experience</p>
                    <h1 class="app-title">The Application</h1>
                    <p class="app-text md-container">Royal Experience is a luxury full service concierge and hospitality company that simplifies the client's life Through innovative software that can be found at the users fingertips. Wherever a customer is traveling and whatever they want to experience, the business R.E, can accommodate them efficiently, conveniently and without the hassle of time consuming event planning.</p>
                    <button class="app-learn-button" style="display:none;">Learn More</button>
                </div>
            </div>
        </div>
        <div>
            <img :src="require('../../assets/Desktop/Home_Landing/home_Phone_Img.png')" alt="Phone Display">
        </div>
        <div class="mobile-text">
            <p class="app-text">Royal Experience is a luxury full service concierge and hospitality company that simplifies the client's life Through innovative software that can be found at the users fingertips. Wherever a customer is traveling and whatever they want to experience, the business R.E, can accommodate them efficiently, conveniently and without the hassle of time consuming event planning.</p>
        </div>
        <re-panel-nav class="flex right lg-container" style="width:215px;"
            v-on:app="sendMessage('re-the-applciation')"
            v-on:offer="sendMessage('re-the-offering')"
            v-on:company="sendMessage('re-company-breakdown')"
        >
        </re-panel-nav>
    </div>
</template>

<script>
    import Panel_Nav from './Panel_Nav.vue'

    export default {
        data () {
            return {
            }
        },
        mounted: function() {
            let nav_location = document.querySelectorAll('.app-container')[0].querySelectorAll('.ta-item')[0]
            nav_location.style['font-size'] = '15px';
            nav_location.style['color'] = '#DAAE3E';
        },
        components: {
            're-panel-nav': Panel_Nav
        },
        methods: {
            sendMessage(message){
                this.$emit('scroll_location', message)
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .app-container {
            height: 1255px !important;
            flex-direction: column !important;
        }

        .mobile-direction {
            flex-direction: column !important;
        }

        .mobile-center {
            display: flex !important;
            justify-content: center !important;
        }

        .page-num {
            margin: 25px auto!important;
        }

        .mobile-text {
            display:block !important;
            text-align: center !important;
        }

        .app-title {
            margin: 15px 0 0 0 !important;
       }
    }

    .mobile-text {
        display:none;
    }

    .page-num {
        margin: 25px 20px 0 0;
    }

    .app-container {
        height: 925px;
        background-color: #FFFFFF;
        overflow: hidden;
    }

    .app-royal-text {
        color: #DAAE3E;
        font-family: Trirong;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 2.31px;
        line-height: 20px;
    }

    .app-title {
        color: #333333;
        font-family: Trirong;
        font-size: 32px;
        font-weight: 800;
        line-height: 44px;
    }

    .app-text {
        color: #333333;
        font-family: Trirong;
        font-size: 16px;
        letter-spacing: 1px;
        line-height: 28px;
        width: 374px;
    }

    .app-learn-button {
        height: 52px;
        width: 167px;
        background-color: #244F76;
        outline: none;
        cursor: pointer;
        color: #FFFFFF;
        font-family: Oswald;
        font-size: 11px;
        font-weight: 400;
        letter-spacing: 3.67px;
        line-height: 15px;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/The_Application.vue